import { m } from '../../mithril';
import { ImageButton } from '../button/image.button';
import { MaterialIcon } from '../icon/icons';
import { addStyles } from '../theme';
import { InputState } from './input.state';
import { RadioInputState } from './radio.input.state';
import { CSS, Style } from './radio.input.style';

addStyles(Style);

export const RadioInput = {
	view(state: RadioInputState) {
		const classList = [
			CSS.container,
			`${CSS.container}--${state.id}`,
			`${CSS.container}--${state.label.toLowerCase()}`,
		];

		if (state.disabled) {
			classList.push(CSS.disabled);
		}

		const className = classList.join(' ');

		const onChange = (e) => RadioInput.onChange(state);
		return m('div', { className, onclick: onChange }, [
			state.value ? ImageButton.view(MaterialIcon.RADIO_SELECTED) : ImageButton.view(MaterialIcon.RADIO),
			m('span', { className: CSS.label }, state.label),
		]);
	},

	onChange(state: InputState<boolean>) {
		state.setValue(true);
	},
};
